import React, { FC, useState, Fragment, useEffect } from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useTranslation } from 'react-i18next';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

type MultiSelectSettingProps = {
    setting: { id: number }[];
    settingValue: { id: number }[];
    propertyName: string;
    label: string;
    handleTeethPropertySelection: (propertyName: string, settingValue: { id: number }[]) => void;
};

const MultiSelectSetting: FC<MultiSelectSettingProps> = ({
    setting,
    propertyName,
    settingValue,
    label,
    handleTeethPropertySelection,
}: MultiSelectSettingProps) => {
    const { t: translate } = useTranslation(['construction-props']);
    const [val, setVal] = useState<{ id: number }[]>([]);

    useEffect(() => {
        setVal(settingValue || []);
    }, [settingValue]);

    const handleChange = (_: React.SyntheticEvent, value: { id: number }[]) => {
        setVal(value);
        handleTeethPropertySelection(propertyName, value);
    };

    return (
        <Autocomplete
            multiple
            fullWidth
            options={setting}
            onChange={handleChange}
            disableCloseOnSelect
            getOptionLabel={(option) => option.id.toString()}
            value={val}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(props, option, { selected }) => (
                <li {...props}>
                    <Checkbox
                        color="secondary"
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {option.id}
                </li>
            )}
            style={{ marginTop: 10 }}
            renderInput={(params) => <TextField {...params} label={translate(label)} />}
        />
    );
};

export default MultiSelectSetting;
